import React, {useEffect, useState} from 'react';
import {
    Card,
    CardBody,
    CardTitle,
} from 'reactstrap';

import {
    ARE_YOU_SHURE_MSG,
    ARE_YOU_SHURE_TITLE,
    deleteMsg,
    error,
    LIST,
    NO,
    warning,
    YES
} from "../../../components/i18n/i18n";
import {confirmAlert} from 'react-confirm-alert';
import {ActiveFormatter} from "../../../components/tables/activeFormater";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {ButtonTableDelete, ButtonTableEdit} from "../../../components/buttons/buttonsActions";
import {showToastCustom} from "../../../components/toast/customToast";
import {confGlobalService} from "../../../jwt/_services/configuration/confGlobalService";
import {showLoader} from "../../../components/loader/loader";


export default function ConfGlobalList(props) {

    const [sizePerPage, setSizePerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [totalSize, setTotalSize] = useState(10);
    const [listItems, setListItems] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        refreshDataList(page, currentIndex, sizePerPage);
    }, []);

    const handleTableChange = (type, {page, sizePerPage}) => {
        let index = (page - 1) * sizePerPage
        refreshDataList(page, index, sizePerPage);
    };

    const refreshDataList = (page, currentIndex, sizePerPage) => {
        setLoading(true);
        confGlobalService.getPagedList(currentIndex, sizePerPage)
            .then(result => {
                if (result){
                    setListItems(result.data);
                    setTotalSize(result.total);
                    setCurrentIndex(currentIndex);
                    setPage(page);
                    setSizePerPage(sizePerPage);
                } else {
                    setListItems([]);
                    setTotalSize(0);
                    setCurrentIndex(1);
                    setPage(1);
                    setSizePerPage(10);
                }
                setLoading(false);
            })
            .catch(errorMessage => {
                setLoading(false);
                setListItems([]);
                setTotalSize(0);
                setCurrentIndex(1);
                setPage(1);
                setSizePerPage(10);
                showToastCustom(error, errorMessage);
            });
    }

    const confirmDelete = (data) => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            deleteItem(data)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    };

    const deleteItem = (data) => {
        setLoading(true);
        confGlobalService.deleteItem(data.id)
            .then(_ => {
                setLoading(false);
                setListItems(listItems.filter(register => register.id !== data.id));
                showToastCustom(warning, deleteMsg, true);
            });
    }

    const editItem = (data) => {
        const itemToEdit = listItems.find(n => n.id === data.id);
        props.beginEdit(itemToEdit);
    }

    //********* Column Formatters *****************
    const photoFormatter = (cell, row) => {
        return (
            <ActiveFormatter active={row.showPhoto}/>
        );
    }

    const bookingFormatter = (cell, row) => {
        return (
            <ActiveFormatter active={row.showBooking}/>
        );
    }

    const walletFormatter = (cell, row) => {
        return (
            <ActiveFormatter active={row.showWallet}/>
        );
    }

    const actionsFormatter = (cell, row) => {
        return (
            <div className="float-left">
                <ButtonTableDelete onClick={() => confirmDelete(row)}/>
                <ButtonTableEdit onClick={() => editItem(row)}/>
            </div>
        );
    }

    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'url',
        text: 'URL',
        headerStyle: {width: '150px'},
    }, {
        dataField: 'userSivex',
        text: 'Usuario',
        headerStyle: {width: '50px'},
    }, {
        dataField: 'stepOne',
        text: 'Paso 1',
        headerStyle: {width: '50px'},
    }, {
        dataField: 'stepTwo',
        text: 'Paso 2',
        headerStyle: {width: '50px'},
    }, {
        dataField: 'datamapAndroid',
        text: 'Datamap Android',
        headerStyle: {width: '50px'},
    }, {
        dataField: 'datamapIos',
        text: 'Datamap IOS',
        headerStyle: {width: '50px'},
    }, {
        isDummyField: true,
        text: 'Acción',
        formatter: actionsFormatter
    }
    ];

    return (
        <div>
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-list-alt mr-2"> </i>{LIST}
                </CardTitle>
                <CardBody className="">
                    {loading ? showLoader() :
                            <BootstrapTable
                                striped hover
                                tableHeaderClass='mb-0'
                                remote
                                keyField="id"
                                data={listItems}
                                columns={columns}
                                pagination={paginationFactory({page, sizePerPage, totalSize})}
                                onTableChange={handleTableChange}
                            />
                    }
                </CardBody>
            </Card>
        </div>
    )
}
